
export const openHouse = {
  title: "Journée Portes Ouvertes",
  description: "Rejoignez-nous pour découvrir notre école !",
  subtitle: "Nous sommes impatients de vous montrer pourquoi Gándara est le choix idéal pour l'avenir académique de votre enfant !",
  bookVisit: "Réservez votre visite",
  lastSpots: "Dernières places disponibles pour notre prochaine Journée Portes Ouvertes ! Réservez maintenant !",
  discover: {
    title: "Découvrez Gándara International School",
    description: "lors d'une visite personnalisée sur réservation, dès la première semaine de septembre."
  },
  methodology: {
    title: "À Gándara, nous croyons en l'apprentissage personnalisé",
    description: "adapté à chaque élève, et au développement des compétences pour un monde global."
  },
  flexibility: {
    title: "Nos portes vous sont ouvertes tous les jours !",
    description: "Nous comprenons que les horaires familiaux peuvent être compliqués, c'est pourquoi nous offrons une flexibilité maximale pour que vous puissiez nous rendre visite n'importe quel jour."
  }
};
